<div class="disclaimer">
  <lg-alert
    [wysiwygContainer]="'Footer Component'"
    class="lg-alert wysiwyg"
    dotcomFrontendWysiwyg
    lgContainer
    variant="generic"
  >
    <div [innerHTML]="footerDisclaimerText | safeHtml"></div>
  </lg-alert>
</div>
